// src/data/teamsData.js
// Pubg players
import pubgPlayerBenja from '../assets/images/teams-player-pubg-benja.png';
import pubgPlayerEmikxz from '../assets/images/teams-player-pubg-emikxz.png';
import pubgPlayerCapitan from '../assets/images/teams-player-pubg-capitan.png';
import pubgPlayerPipa from '../assets/images/teams-player-pubg-pipa.png';

// Sim players
import simPlayerJuanpa from '../assets/images/teams-player-sim-juampa.png';
import simPlayerGaona from '../assets/images/teams-player-sim-gaona.png';

// Valo players
import valoPlayerToomen from '../assets/images/teams-player-valo-toomen.png';
import valoPlayerFawzi from '../assets/images/teams-player-valo-fawzi.png';
import valoPlayerDesru from '../assets/images/teams-player-valo-desru.png';

// Template player
import templatePlayerNoImg from '../assets/images/teams-player-template.png';

// Backgrounds para cada juego
import pubgBg from '../assets/images/teams-pubg-bg.png';
import valorantBg from '../assets/images/teams-valo-bg.png';
import simRacingBg from '../assets/images/teams-sim-bg.png';
import pergaminoPubg from '../assets/images/teams-pubg-perg.png';
import pergaminoValo from '../assets/images/teams-valo-perg.png';
import pergaminoSim from '../assets/images/teams-sim-perg.png';


export const TEAMS_DATA = {
  PUBG: {
    backgroundImage: pubgBg,
    pergaminoImage: pergaminoPubg,
    roster: [
      { 
        nickname: "Benja", 
        fullName: "Benjamin Selman Rojas",
        image: pubgPlayerBenja
      },
      { 
        nickname: "Emikxz", 
        fullName: "Emiliano Fidalgo",
        image: pubgPlayerEmikxz
      },
      { 
        nickname: "Capitan", 
        fullName: "Facundo Solsona",
        image: pubgPlayerCapitan
      },
      { 
        nickname: "Pipa", 
        fullName: "Rafael Ruppel",
        image: pubgPlayerPipa
      },
    ],
    staff: [
      { 
        nickname: "Black", 
        fullName: "Fernando Mendelson",
        image: templatePlayerNoImg
      }
    ]
  },
  SIMRACING: {
    backgroundImage: simRacingBg,
    pergaminoImage: pergaminoSim,
    roster: [
      { 
        nickname: "Juanpa", 
        fullName: "Juan Pablo Cano",
        image: simPlayerJuanpa
      },
      { 
        nickname: "Seba Gaona", 
        fullName: "Sebastián Gaona",
        image: simPlayerGaona
      },
      { 
        nickname: "Juanjo", 
        fullName: "Juan Jose Ayala",
        image: templatePlayerNoImg
      },
      { 
        nickname: "Marcelo", 
        fullName: "Marcelo Fleitas",
        image: templatePlayerNoImg
      }
    ],
    staff: [
      { 
        nickname: "PomberMD", 
        fullName: "Erwin Barboza Molinas",
        image: templatePlayerNoImg
      }
    ]
  },
  VALORANT: {
    backgroundImage: valorantBg,
    pergaminoImage: pergaminoValo,
    roster: [
      { 
        nickname: "Toomen", 
        fullName: "Axel Rolón",
        image: valoPlayerToomen
      },
      { 
        nickname: "fawzi", 
        fullName: "Maximiliano Casco",
        image: valoPlayerFawzi
      },
      { 
        nickname: "Desru", 
        fullName: "Valentino Castorino",
        image: valoPlayerDesru
      },
      { 
        nickname: "Hen", 
        fullName: "Henrich Mohr Benkenstein",
        image: templatePlayerNoImg
      },
      { 
        nickname: "Mercy", 
        fullName: "Francis Jara Ramirez",
        image: templatePlayerNoImg
      }
    ],
    staff: [
      { 
        nickname: "Kuzask", 
        fullName: "Mauro Rutkowski",
        image: templatePlayerNoImg
      }
    ]
  }
};